/**
 * Default booking status for new assignments from v1 status catalog shape.
 * Import only from `*.http.ts`, services, or UI that reads legacy status payloads.
 */

import { isBookingStatus } from 'v1/helpers/byModel/StatusHelper';

export type BookingStatusSnapshot = {
  id?: number;
  name?: string;
  colour?: string | null;
  status_type?: string | null;
  order?: number | null;
};

/**
 * Default workflow status for a new booking (confirmed when present, else first booking status).
 * Uses {@link isBookingStatus} (status_type group), not entity_type string checks.
 */
export function pickInitialBookingStatus(
  statuses: BookingStatusSnapshot[]
): BookingStatusSnapshot | null {
  const ordered = statuses
    .filter(
      (status): status is BookingStatusSnapshot =>
        Boolean(status) && isBookingStatus(status)
    )
    .sort(
      (a, b) =>
        (a.order ?? Number.MAX_SAFE_INTEGER) -
        (b.order ?? Number.MAX_SAFE_INTEGER)
    );

  const confirmed = ordered.find(
    status => String(status.status_type ?? '').toUpperCase() === 'CONFIRMED'
  );
  if (confirmed) {
    return confirmed;
  }
  return ordered[0] ?? null;
}
